module.exports = __webpack_public_path__ + "img/decoration-sm.16c8a853.svg";